import {
  Card,
  Flex,
  Heading,
  ScrollView,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@aws-amplify/ui-react";
import React, { useEffect, useMemo } from "react";
import { Quiz } from "../../../API";
import { Team } from "../../game/Types/TeamTypes";
import { ResultsTableRow } from "./ResultsTableRow";
import { QuestionNumberButton } from "../../class";
import { useQueries } from "@tanstack/react-query";
import { getTeamPlayers } from "../../game/services/getTeamPlayers";
import { Player } from "../../game/Types/GameTypes_dep";
import { AnswerResult, GameState } from "../../game/Types/GameTypes";
import { RaisedButton } from "../../../components";
import { FaDownload } from "react-icons/fa";
import { exportResultsTable } from "../utils/exportResultsTable";

export default function ResultsTable({
  quiz,
  teams,
}: {
  quiz: Quiz | null | undefined;
  teams: Team[];
}) {
  const questions = useMemo(() => {
    return (
      quiz?.Questions?.items?.map((quizQuestion) => {
        return quizQuestion?.question;
      }) ?? []
    );
  }, [quiz]);

  useEffect(() => {
    console.log("questions", questions);
  }, [questions]);

  // const { data: players } = useQueries(["team", team.id, "players"], async () => {
  //   return await getTeamPlayers(team.id);
  // });
  const playerQueries = useQueries({
    queries: teams.map((team) => ({
      queryKey: ["team", team.id, "players"],
      queryFn: async () => {
        return await getTeamPlayers(team.id);
      },
    })),
  });

  const players = useMemo(() => {
    const players = playerQueries
      .flatMap((playerQuery) => playerQuery.data)
      .filter(Boolean) as Player[];

    return players;
    // const fixedPlayers = players.map((player) => {
    //   const team = teams.find((team) => team.id === player.groupId);
    //   if (!team) {
    //     return { ...player, teamNumber: 0, gameData: undefined };
    //   }
    //   const teamNumber = teams.indexOf(team) + 1;
    //   const gameData = team.gameData;
    //   return {
    //     ...player,
    //     teamNumber,
    //     gameData,
    //   };
    // });

    // return fixedPlayers;
  }, [playerQueries]);

  const teamPlayers = useMemo(() => {
    const fixedPlayers = players.map((player) => {
      const team = teams.find((team) => team.id === player.groupId);
      if (!team) {
        return { ...player, teamNumber: 0, gameData: undefined };
      }
      const teamNumber = teams.indexOf(team) + 1;
      const gameData = team.gameData;
      return {
        ...player,
        teamNumber,
        gameData,
      };
    });

    return fixedPlayers;
  }, [players, teams]);

  return (
    <>
      <Card boxShadow={"large"}>
        <Flex direction={"column"} gap={"small"}>
          <Flex justifyContent={"space-between"} alignItems={"end"}>
            <Heading paddingBottom={"xs"}>Results</Heading>
            <RaisedButton
              variation="link"
              onClick={() => {
                exportResultsTable(players, teams, questions);
              }}
            >
              <FaDownload />
            </RaisedButton>
          </Flex>
          <ScrollView>
            <Table size="small" variation="striped">
              <TableHead>
                <TableRow>
                  <TableCell as="th" width={"75px"} textAlign={"center"}>
                    Players
                  </TableCell>
                  <TableCell as="th" width={"75px"} textAlign={"center"}>
                    Team #
                  </TableCell>
                  <TableCell as="th" width={"75px"} textAlign={"center"}>
                    Score
                  </TableCell>
                  <TableCell as="th" width={"500px"}>
                    <Flex justifyContent="start" paddingLeft={"small"}>
                      {questions?.map((question, i) => (
                        // <Text>Hi</Text>
                        <QuestionNumberButton
                          key={i}
                          question={question}
                          qNumber={i + 1}
                        />
                      ))}
                    </Flex>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {teamPlayers.map((player) => (
                  <ResultsTableRow
                    key={player.userId}
                    teamNumber={player.teamNumber}
                    playerName={player.nickname}
                    questions={questions}
                    gameData={
                      player.gameData ?? {
                        answerResults: [] as AnswerResult[],
                        questionIndex: 0,
                        gameState: GameState.WAITING,
                        currentAnswer: [] as number[],
                      }
                    }
                  />
                ))}
              </TableBody>
            </Table>
          </ScrollView>
        </Flex>
      </Card>
    </>
  );
}
